export const HaierEncryptKey = 'login token';

export const PaymentRedirectUrlKey = 'payment_redirect_url';
